// D+ per-CP web build routing — client hook (web only). See web/devserver.js
// `GET /__web-build`. After a login token is written (and once at boot when a
// token already exists) ask the devserver which web build this user's CP
// should run. The devserver sets the cm_web_branch / cm_web_build cookies;
// when the answer differs from the build THIS page was served from
// (window.__CM_WEB_BUILD, injected by the devserver) we reload once so the
// ingress routes us to that build. On logout we clear the cookies.
//
// Reload guard: at most one reload per 5 minutes (sessionStorage), so a build
// name the canary does not have (it serves develop) can never loop.
var GUARD_KEY = "cm_web_build_reload_at";
var GUARD_MS = 5 * 60 * 1000;
var inFlight = false;

function served() {
  return typeof window !== "undefined" ? window.__CM_WEB_BUILD : undefined;
}

function reloadAllowed() {
  try {
    var last = Number(window.sessionStorage.getItem(GUARD_KEY) || 0);
    if (last && Date.now() - last < GUARD_MS) return false;
    window.sessionStorage.setItem(GUARD_KEY, String(Date.now()));
    return true;
  } catch (_) {
    return false; // no sessionStorage → cannot prove the guard → never reload
  }
}

function checkWebBuild(token) {
  // __CM_WEB_BUILD is only set by devserver.js; plain webpack-dev / static
  // hosting has no /__web-build, so do nothing there.
  if (!token || !served() || typeof fetch !== "function" || inFlight) return;
  inFlight = true;
  fetch("/__web-build", {
    headers: { Authorization: token },
    credentials: "same-origin",
    cache: "no-store",
  })
    .then(function (r) {
      return r.json();
    })
    .then(function (j) {
      var want = (j && j.web_build) || "develop";
      // Small delay so redux-persist's pending write of the new session lands
      // before the page is torn down.
      if (want !== served() && reloadAllowed())
        setTimeout(function () {
          // Go to the app root, not reload(): after login the SPA URL is /cm/main/home/Home/undefined
          // (pre-existing route bug), and hard-loading that URL blanks the app.
          window.location.replace("/");
        }, 300);
    })
    .catch(function () {})
    .then(function () {
      inFlight = false;
    });
}

function clearWebBuild() {
  if (!served() || typeof fetch !== "function") return;
  fetch("/__web-build?clear=1", {
    credentials: "same-origin",
    cache: "no-store",
  }).catch(function () {});
}

module.exports = { checkWebBuild: checkWebBuild, clearWebBuild: clearWebBuild };
